import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { Subscription } from "rxjs";
import { IUser } from "src/app/models/user.model";
import { ZpDataService } from "src/app/services/zp-data.service";
import { UserInfoService } from "src/app/services/user-info.service";
import { DelegateHelpers } from "src/app/helpers/delegate-helpers";
import { Router, ActivatedRoute } from "@angular/router";
import { SideNavBarVisibilityService } from "src/app/services/side-nav-bar-visibility.service";
import { IDataEntryForm } from "src/app/models/data-entry.model";
import { GetInfoAndPassService } from "../../services/get-info-and-pass.service";
import { ThemeService } from "src/app/theme/theme-service.service";
import { ZPNotification } from "src/app/models/zpnotification";
import { NotificationService } from "src/app/services/notification.service";
import { PreviousUrlService } from "src/app/services/previous-url.service";

@Component({
    selector: "app-shared-plan-summary",
    templateUrl: "./shared-plan-summary.component.html",
    styleUrls: ["./shared-plan-summary.component.scss"],
    standalone: false
})
export class SharedPlanSummaryComponent implements OnInit, OnDestroy {
  @ViewChild("textarea") public textarea: ElementRef<HTMLTextAreaElement>;
  public allMySharedPlans: {}[];
  public filteredSharePlans: {}[];
  public headElements = ["First", "Last"];
  public subscription: Subscription;
  public planCountText = "No plans";
  public myUser: IUser;
  public chosenPlan;
  public showButton: boolean = true;
  public mySubscription: Subscription;
  public delegateId: string;
  public sharedPlan;
  public Id;
  public dummySectionTitle = "Shared Plans";
  public hasPlan;
  public id;
  public dataIsLoaded: boolean = false;
  public subscription4: Promise<void>;
  public logoSponsor: boolean;
  public user: any;
  public refCode: any;
  public logoUrl: any;
  public professionalCompany: string;
  public disabled: boolean = false;
  public assetsPermission: boolean;
  public debtsPermission: boolean;
  public dailyLifePermission: boolean;
  public digitalLifePermission: boolean;
  public wishesPermission: boolean;
  public questionMarkMobile: boolean;
  public activeTheme: any;
  public isDefaultTheme: boolean;
  public sharedPlanUser: any;
  public sharedPlanCategories: any;
  public subscription1: any;
  public hideSponsor: boolean;
  public mySharedPlans: any;
  public mySharedPlan: Promise<any[]>;
  public companyDetails: any;
  public professionalFirstName: string;
  public professionalLastName: string;
  public messageToSend: string = "";
  public professionalId: string;
  public messageHasBeenSent: boolean = false;
  @ViewChild("closeButton") closeButton: ElementRef;
  retrievedMessages: any[];
  openModal: boolean;
  isNFZ: any;
  previousLink: any;
  public nudgeEmailToSend: {
    mailSubject: string;
    mailBody: string;
    mode: string;
    userList: any;
  };
  inputEmailSubject: string;
  inputEmailBody: string;
  statusAssetsTooltipMobile: any;
  statusDetsTooltipMobile: any;
  statusDailyLifeTooltipMobile: any;
  statusDigitalLifeTooltipMobile: any;
  statusWishesTooltipMobile: any;
  showClient: any;
  emailSubject: any = "Email Subject";
  emailBody: any = "Email Body";
  editableTemplateBody: any;
  bannerModalCanBeOpened: boolean;
  displayNudgePlanHolderBanner: boolean;
  modalTitle: string;

  constructor(
    private zenplansDataProvider: ZpDataService,
    private userInfo: UserInfoService,
    private delegateHelpers: DelegateHelpers,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private getInfoAndPassService: GetInfoAndPassService,
    public themeService: ThemeService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private notifications: NotificationService,
    private previousUrl: PreviousUrlService
  ) {
    this.subscription = this.userInfo.getMessage().subscribe((user) => {
      this.myUser = JSON.parse(user);
      console.log(this.myUser);
    });
    this.activatedRoute.paramMap.subscribe((params) => {
      this.Id = params.get("id");
    });
  }

  async ngOnInit() {
    this.activeTheme = this.themeService.active;
    if (this.activeTheme.name != "defaultTheme") {
      this.isDefaultTheme = false;
    }
    // this.updateScreen();
    if (window.screen.width <= 1100) {
      this.questionMarkMobile = true;
    } else {
      this.questionMarkMobile = false;
    }
    this.previousLink = this.previousUrl.getPreviousUrl();
    console.log("previousLink:", this.previousLink);
    if (
      this.previousLink.includes("/account-created") ||
      this.previousLink.includes("/professional-home-page")
    ) {
      window.location.reload();
    }
    this.dataIsLoaded = false;
    this.allMySharedPlans = await this.zenplansDataProvider.getMySharedPlans();
    console.log("allMySharedPlans - ", this.allMySharedPlans);

    if (this.allMySharedPlans && this.allMySharedPlans.length > 0) {
      this.sharedPlan = this.allMySharedPlans.find(
        (plan) => plan["Id"] == this.Id
      );
      console.log("this.sharedPlan - ", this.sharedPlan);
      this.sharedPlanCategories = await this.zenplansDataProvider.getPlan(
        this.sharedPlan["clientId"]
      );
      let checkIfSharedPlanIsUpgraded =
        this.zenplansDataProvider.checkIfSharedPlanIsUpgraded(
          this.sharedPlanCategories
        );
      console.log(checkIfSharedPlanIsUpgraded);
      // if (this.sharedPlan.clientPlanVersion < 2 || this.sharedPlan.clientPlanVersion == undefined) {
      //   alert(
      //     "This user is a shared plan who did not upgrade his plan yet. He need to log in first and only then you'll be able to get his plan."
      //   );
      //   this.router.navigate(["/delegate-home-page"]);
      // }
      // this.refCode = this.allMySharedPlans.find(refCode => refCode['clientRefCode'] == this.refCode);
      if (
        this.sharedPlan.clientUserType == "planHolder" &&
        this.sharedPlan.clientRefCode
      ) {
        this.logoUrl = await this.zenplansDataProvider.getLogoUrl(
          this.sharedPlan.clientRefCode
        );
        let sharedPlanRefCodeData =
          await this.zenplansDataProvider.retrieveSharedPlanRefCode(
            this.sharedPlan.clientRefCode
          );
        if (sharedPlanRefCodeData) {
          console.log("sharedPlanRefCodeData - ", sharedPlanRefCodeData);
          this.companyDetails = sharedPlanRefCodeData;
          console.log("companyDetails - ", this.companyDetails);
          this.professionalFirstName = sharedPlanRefCodeData.firstName;
          this.professionalLastName = sharedPlanRefCodeData.lastName;
          this.professionalCompany = sharedPlanRefCodeData.company;
          this.professionalId = sharedPlanRefCodeData.professionalId;
          this.hideSponsor = sharedPlanRefCodeData.hideSponsor;
          this.isNFZ = this.companyDetails.nfz;
        }
        // To hide the send button to the professional if the professional is the delegate
        if (this.sharedPlan && this.companyDetails) {
          if (
            this.sharedPlan.delegateId === this.companyDetails.professionalId
          ) {
            this.showButton = false;
            console.log("this.showClient - ", this.showButton);
            console.log(
              "this.companyDetails.professionalId - ",
              this.companyDetails.professionalId
            );
          } else {
            this.showButton = true;
          }
        }
        this.logoSponsor = true;
      }
      if (this.sharedPlan.assetsPermission == "never") {
        this.assetsPermission = true;
      }
      if (this.sharedPlan.debtsPermission == "never") {
        this.debtsPermission = true;
      }
      if (this.sharedPlan.dailyLifePermission == "never") {
        this.dailyLifePermission = true;
      }
      if (this.sharedPlan.digitalLifePermission == "never") {
        this.digitalLifePermission = true;
      }
      if (this.sharedPlan.wishesPermission == "never") {
        this.wishesPermission = true;
      }
    }
    this.dataIsLoaded = true;
    // To check if the user has any conversations
    this.retrievedMessages = await this.zenplansDataProvider.retrieveMessages();
    console.log("retrieveMessages: ", this.retrievedMessages);
    this.nudgeEmailToSend = {
      mailBody: "",
      mailSubject: "",
      mode: "plan_complete",
      userList: [],
    };
    this.checkRemoteStorageForPrepopulatedUser();
  }

  async checkRemoteStorageForPrepopulatedUser() {
    const getRemoteStorage = await this.zenplansDataProvider.getRemoteStorage();
    console.log("getRemoteStorage on init: ", getRemoteStorage);

    // Ensure getRemoteStorage is an array and has at least one entry
    if (!Array.isArray(getRemoteStorage) || getRemoteStorage.length === 0) {
      console.error("No data found in remote storage array");
      this.displayNudgePlanHolderBanner = true;
      return;
    }

    // Extract the shared plan ID
    const sharedPlanId = this.sharedPlan.Id;
    console.log("sharedPlanId: ", sharedPlanId);

    // Check if the sharedPlan.Id exists as a key in the remoteStorage array
    const foundData = getRemoteStorage.find((entry: any) => {
      console.log("Checking entry: ", entry);
      return sharedPlanId in entry.data.data;
    });

    if (foundData) {
      // Access the specific object using the sharedPlanId
      const sharedPlanData = foundData.data.data[sharedPlanId];
      console.log("sharedPlanData: ", sharedPlanData);

      // Check if bannerToDisplayInSharedPlanSummary exists in this object
      if (
        sharedPlanData &&
        "bannerToDisplayInSharedPlanSummary" in sharedPlanData
      ) {
        this.displayNudgePlanHolderBanner = false; // banner exists, so set displayBanner to false
        console.log("Banner found, displayBanner set to false");
      } else if (sharedPlanData && "emailStatus" in sharedPlanData) {
        this.displayNudgePlanHolderBanner = false; // banner exists, so set displayBanner to false
        console.log("Banner found, displayBanner set to false");
      } else {
        this.displayNudgePlanHolderBanner = true;
        console.log("Banner not found");
      }
    } else {
      this.displayNudgePlanHolderBanner = true;
      console.log("sharedPlan.Id not found in remote storage");
    }
  }

  async view($event, section, plan) {
    this.delegateHelpers.seeSharedPlan(section, plan, this.myUser);
    console.log("plan", plan);
    console.log("section", section);
    if (section == "summary") {
      if (
        plan["assetsPermission"] != "now" &&
        plan["assetsPermission"] != "contributor" &&
        plan["debtsPermission"] != "now" &&
        plan["debtsPermission"] != "contributor" &&
        plan["dailyLifePermission"] != "now" &&
        plan["dailyLifePermission"] != "contributor" &&
        plan["digitalLifePermission"] != "now" &&
        plan["digitalLifePermission"] != "contributor"
      ) {
        this.router.navigate(["/request-access"]);
      }
      await this.delegateHelpers.delegateChooseSharedPlan(plan, this.myUser);
      this.router.navigate(["/financial-summaries"]);
    }
  }

  request($event, plan?) {
    this.getInfoAndPassService.getInfoAndPass(this.sharedPlan);
    this.router.navigate(["/request-access/" + this.sharedPlan.clientId]);
  }

  inputChangeEmail(event: any, element: string) {
    if (element === "input") {
      this.inputEmailSubject = event.target.value;
      this.nudgeEmailToSend.mailSubject = this.inputEmailSubject;
    }
  }

  handleChangeSubject(value: string) {
    this.nudgeEmailToSend.mailSubject = value;
  }

  insertText(selectedValue: string) {
    const disabledValues = [
      "Professional Referral Code",
      "Professional Referral Link",
    ];

    const textToInsert = `${selectedValue}`;
    const cursorPosition = this.textarea.nativeElement.selectionStart;
    const textBeforeCursor = this.textarea.nativeElement.value.substring(
      0,
      cursorPosition
    );
    const textAfterCursor =
      this.textarea.nativeElement.value.substring(cursorPosition);
    const newValue = textBeforeCursor + textToInsert + textAfterCursor;

    this.textarea.nativeElement.value = newValue;

    if (disabledValues.includes(selectedValue)) {
      setTimeout(() => {
        this.disableInsertedValue(selectedValue);
      }, 0);
    }
  }

  disableInsertedValue(selectedValue: string) {
    const textareaValue = this.textarea.nativeElement.value;
    const disabledStartTag = `<disabled>[`;
    const disabledEndTag = `]</disabled>`;

    const startIndex = textareaValue.indexOf(`[${selectedValue}]`);
    if (startIndex !== -1) {
      const endIndex = startIndex + selectedValue.length + 2;
      const disabledValue = disabledStartTag + selectedValue + disabledEndTag;
      this.textarea.nativeElement.value =
        textareaValue.substring(0, startIndex) +
        disabledValue +
        textareaValue.substring(endIndex);
    }
  }

  async sendNudge(selectedUserId: any) {
    const textareaValue = this.textarea.nativeElement.value;
    console.log("selectedUserId: ", selectedUserId);
    this.nudgeEmailToSend.mailBody = this.insertContentIntoBody(
      textareaValue,
      this.emailBody
    );
    // console.log("emailBody after being inserted back: ", this.emailBody);
    if (this.inputEmailSubject && this.inputEmailSubject.trim() !== "") {
      this.nudgeEmailToSend.mailSubject = this.inputEmailSubject;
    } else {
      this.nudgeEmailToSend.mailSubject = this.emailSubject;
    }
    this.nudgeEmailToSend.userList = [{ Id: selectedUserId }];
    this.nudgeEmailToSend.mode = "account_created_nudge";
    console.log("emailToSend - ", this.nudgeEmailToSend);
    // Object to send for remoteStorage
    const bannerToDisplayInSharedPlanSummary = {
      [selectedUserId]: {
        bannerToDisplayInSharedPlanSummary: {
          nudgeSent: true,
        },
      },
    };
    // Send the entire object to the API
    const remoteStorageToSend = await this.zenplansDataProvider.remoteStorage({
      data: bannerToDisplayInSharedPlanSummary,
    });
    console.log("remoteStorageToSend:", remoteStorageToSend);
    try {
      const response = await this.zenplansDataProvider.sendInvites(
        this.nudgeEmailToSend
      );
      // alert("Your nudge has been sent successfully.");
      console.log("response", response);
      if (response && response.success) {
        this.checkRemoteStorageForPrepopulatedUser();
      }
      this.inputEmailSubject = "";
      this.nudgeEmailToSend.mailSubject = this.emailSubject;
      this.nudgeEmailToSend.mailBody = textareaValue;
      this.bannerModalCanBeOpened = false;
    } catch (error) {
      alert("There was a problem sending your nudge. Please try again later.");
      console.error(error);
    }
  }

  async sendMessage(message, recipientId) {
    console.log(message, recipientId);
    let result = await this.zenplansDataProvider.sendMessage(
      message,
      recipientId
    );
    console.log(result);
    if (result && result.success) {
      this.messageToSend =
        "Hi there, I would like to discuss my own planning requirements with you. Please could we arrange a call for next week? Many thanks.";
      this.notifications.changeMessage(
        new ZPNotification("Message sent - view in messages to send follow up.")
      );
      this.messageHasBeenSent = true;
      setTimeout(() => {
        this.messageHasBeenSent = false;
        this.closeButton.nativeElement.click();
      }, 3000);
    } else {
      this.notifications.changeMessage(
        new ZPNotification("Message failed to send. Please try again later.")
      );
    }
  }

  openModalForProfessional() {
    this.bannerModalCanBeOpened = true;
  }

  async statusModal() {
    this.bannerModalCanBeOpened = true;
    this.modalTitle = "Notify client that you have created their plan";
    this.loadTemplates();
  }

  async loadTemplates() {
    const template =
      await this.zenplansDataProvider.getProfessionalInviteTemplateForModal(
        "account_created_nudge"
      );
    console.log("template: ", template);
    this.emailSubject = template.mail_template.subject;
    this.emailBody = template.mail_template.body;
    console.log("emailBody before being extracted: ", this.emailBody);
    this.editableTemplateBody = this.extractContentFromBody(
      template.mail_template.body
    );
  }

  extractContentFromBody(htmlString) {
    let bodyContentRegex = /<div id="body">([\s\S]*?)<\/div>/;
    let match = bodyContentRegex.exec(htmlString);
    if (match) {
      let divContent = match[1];
      return divContent.replace(/<br>/gi, "\n");
    }
  }

  insertContentIntoBody(str: string, htmlString: string) {
    let html = str.replace(/\n/gi, "<br>");
    let updatedHtmlString = htmlString.replace(
      /(<div id="body">)([\s\S]*?)(<\/div>)/,
      `$1${html}$3`
    );
    console.log("updatedHtmlString: ", updatedHtmlString);
    return updatedHtmlString;
  }

  displayCurrentSection(section?: string) {
    this.router.navigate(["/delegate-home-page"]);
  }

  async checkIfAnyConversations() {
    // check if this.sharedPlan.clientProfessionalId exists in this.retrieveMessages array of objects as recipientId or senderId
    let selectedUserDelegateId = this.sharedPlan.clientProfessionalId;
    console.log("selectedUserDelegateId: ", selectedUserDelegateId);
    let selectedUserMessages = [];
    for (let i = 0; i < this.retrievedMessages.length; i++) {
      if (
        this.retrievedMessages[i].recipientId == selectedUserDelegateId ||
        this.retrievedMessages[i].senderId == selectedUserDelegateId
      ) {
        selectedUserMessages.push(this.retrievedMessages[i]);
      }
    }
    console.log("selectedUserMessages: ", selectedUserMessages);
    if (selectedUserMessages.length > 0) {
      this.openModal = false;
      this.router.navigate(["/delegate-home-page"]);
    } else {
      this.openModal = true;
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
